// const refreshToken = async (user, setIsLoading, doSetUser) => {
//   const refresh = await fetch(
//     `http://${process.env.REACT_APP_DOMAIN}/refreshToken`,
//     {
//       headers: {
//         "Content-Type": "application/json",
//       },
//       method: "POST",
//       body: JSON.stringify({ token: user.refreshToken }),
//     }
//   );
//   const refreshData = await refresh.json();
//   localStorage.setItem("brt-jwt", JSON.stringify(refreshData));
//   doSetUser(refreshData);
//   setIsLoading(false);
// };

export const setToken = async (setIsLoading, doSetUser) => {
  const brtJWT = localStorage.getItem("brt-jwt");
  if (brtJWT) {
    const verify = await sendPostRequest("verifyToken");
    const verifyData = await verify.json();
    if (verifyData?.errMessage) {
      localStorage.removeItem("brt-jwt");
      //  refreshToken(user, setIsLoading, doSetUser);
      setIsLoading(false);
    } else {
      doSetUser(verifyData);
      setIsLoading(false);
    }
  } else {
    setIsLoading(false);
  }
};

export const compareObjects = (obj1, obj2) => {
  // Check if both arguments are objects
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return false;
  }

  // Get the keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if each key in obj1 exists in obj2 with the same value
  for (let key of keys1) {
    if (!obj2.hasOwnProperty(key) || obj1[key] !== obj2[key]) {
      return false;
    }
  }

  // If all checks pass, objects are equal
  return true;
};

export const sendGetRequest = async (url, isWithAuth) => {
  const brtJWT = localStorage.getItem("brt-jwt");
  const headers = {
    "Content-Type": "application/json",
  };

  if (isWithAuth) headers.authorization = `Bearer ${brtJWT}`;

  const request = await fetch(`${process.env.REACT_APP_DOMAIN}/${url}`, {
    headers,
  });
  return request;
};

export const sendPostRequest = async (url, body) => {
  const brtJWT = localStorage.getItem("brt-jwt");
  const request = await fetch(`${process.env.REACT_APP_DOMAIN}/${url}`, {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${brtJWT}`,
    },
    method: "POST",
    body: body ? JSON.stringify(body) : undefined,
  });

  return request;
};

export const sendPatchRequest = async (url, body) => {
  const brtJWT = localStorage.getItem("brt-jwt");
  const request = await fetch(`${process.env.REACT_APP_DOMAIN}/${url}`, {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${brtJWT}`,
    },
    method: "PATCH",
    body: body ? JSON.stringify(body) : undefined,
  });

  return request;
};

export const sendDeleteRequest = async (url, body) => {
  const brtJWT = localStorage.getItem("brt-jwt");
  const request = await fetch(`${process.env.REACT_APP_DOMAIN}/${url}`, {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${brtJWT}`,
    },
    method: "DELETE",
    body: body ? JSON.stringify(body) : undefined,
  });

  return request;
};

export const formatPhoneNumber = (phoneNumber) =>
  `${process.env.REACT_APP_DEFAULT_AREA_CODE}${phoneNumber}`;

// First letter of a Canadian postal code -> province
const PROVINCE_BY_POSTAL_LETTER = {
  A: "NL",
  B: "NS",
  C: "PE",
  E: "NB",
  G: "QC",
  H: "QC",
  J: "QC",
  K: "ON",
  L: "ON",
  M: "ON",
  N: "ON",
  P: "ON",
  R: "MB",
  S: "SK",
  T: "AB",
  V: "BC",
  Y: "YT",
};

const NO_UNIT = ["aucun", "aucune", "none", "n/a", "na", "-"];

// Canada Post style, on two lines:
//   104-25 rue Principale
//   Sutton QC  J0E 2K0
export const formatAddress = (row) => {
  const number = (row.street_number || "").trim().replace(/,+$/, "");
  const street = (row.street_name || "").trim();
  const unit = (row.apartment || "").trim();

  let line1 = [number, street].filter(Boolean).join(" ");
  if (unit && !NO_UNIT.includes(unit.toLowerCase())) {
    // A plain unit number goes in front (104-25 ...); anything else after
    line1 = /^[0-9]+[a-z]?$|^[a-z]$/i.test(unit)
      ? `${unit}-${line1}`
      : `${line1}, ${unit}`;
  }

  const compact = (row.postal_code || "").replace(/\s+/g, "").toUpperCase();
  const isCanadian = /^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/.test(compact);
  const postalCode = isCanadian
    ? `${compact.slice(0, 3)} ${compact.slice(3)}`
    : (row.postal_code || "").trim();
  const province = isCanadian ? PROVINCE_BY_POSTAL_LETTER[compact[0]] : "";

  const line2 = [[(row.city || "").trim(), province].filter(Boolean).join(" "), postalCode]
    .filter(Boolean)
    .join("  ");

  return { line1, line2 };
};
